import { render } from "./ResultBody.vue?vue&type=template&id=5c644292&scoped=true"
import script from "./ResultBody.vue?vue&type=script&lang=js"
export * from "./ResultBody.vue?vue&type=script&lang=js"

import "./ResultBody.vue?vue&type=style&index=0&id=5c644292&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c644292"]])

export default __exports__